import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { BaseApiTemplateService, Core2Config, ApiVisa } from '../../shared';
import { Observable } from 'rxjs';
import { ApiResponseModel } from '../../shared';


@Injectable({
  providedIn: 'root'
})
export class CashLevelReportService extends BaseApiTemplateService<any> {

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "fi/cash-level-reports/backoffice-ep";
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "fi/cash-level-reports/backoffice-ep";
        this.httpClient = http;
      }

      public printCashLevelReport(dtoObject: any, printableFormatHdrGuid:any ,visa: ApiVisa): Observable<ApiResponseModel<any>> {
        let url;
        if (this.endpoint_path && visa.api_domain_url) {
          url = visa.api_domain_url +  Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "fi/cash-level-reports/printable/backoffice-ep?printableFormatHdrGuid="+printableFormatHdrGuid;
        }
        return this.httpClient.post<ApiResponseModel<any>>(
          url,
          dtoObject,
          this.getHttpHeaderBlob(visa)
        );
      }
    
}